import React, { FC } from "react";
import classes from "./HeaderController.module.scss";
import { SaveButton } from "../uikit/atoms/buttons/SaveButton";
import { CancelButton } from "../uikit/atoms/buttons/CancelButton";
import { AllButton } from "../uikit/atoms/buttons/AllButton";
import { DeleteButton } from "../uikit/atoms/buttons/DeleteButton";
import { Navigate, useNavigate } from "react-router-dom";
import { Switch } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import { foreColor } from "../../commons/colors";
type localColumn = {
  [key: string]: boolean;
};
type Props = {
  handleSaveButtonClick: () => void;
  isShowAll: boolean;
  setIsShowAll: React.Dispatch<React.SetStateAction<boolean>>;
  setLocalColumns: React.Dispatch<React.SetStateAction<localColumn[]>>;
};
const HeaderController: FC<Props> = (props) => {
  const navigation = useNavigate();
  const user = useRecoilValue(userState);
  const { handleSaveButtonClick, isShowAll, setIsShowAll, setLocalColumns } =
    props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsShowAll(event.target.checked);
  };

  const handleSetVisibleButtonClick = () => {
    // setIsShowAll(true);
    setLocalColumns((prev) => {
      return prev.map((column) => {
        return { ...column, ...{ [Object.keys(column)[0]]: true } };
      });
    });
  };
  const handleSetInvisibleButtonClick = () => {
    setLocalColumns((prev) => {
      return prev.map((column) => {
        return { ...column, ...{ [Object.keys(column)[0]]: false } };
      });
    });
  };

  return (
    <div className={classes.rootContainer}>
      <div className={classes.leftContents}>
        <div className={classes.buttons}>
          <div>
            <AllButton
              disabled={false}
              onClick={handleSetVisibleButtonClick}
              caption={"Set Visible"}
            />
          </div>
          <div>
            <DeleteButton
              disabled={false}
              onClick={handleSetInvisibleButtonClick}
              caption={"Set Invisible"}
            />
          </div>
        </div>
      </div>
      <div className={classes.rightContents}>
        <div className={classes.switch}>
          <FormControlLabel
            control={<Switch checked={isShowAll} onChange={handleChange} />}
            label={isShowAll ? "Display All" : "Only Visible"}
            sx={
              isShowAll
                ? { color: foreColor(user?.mode ?? "lite") }
                : { color: "#4a4f58" }
            }
          />
        </div>
        <div className={classes.buttons}>
          <div>
            <SaveButton
              disabled={false}
              onClick={handleSaveButtonClick}
              caption={"Save Visibilities"}
            />
          </div>
          <div>
            <CancelButton
              disabled={false}
              onClick={() => navigation("/")}
              caption={"Cancel"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderController;
